import { LoadingButton } from '@mui/lab';
import { Alert, Stack, TextField, Typography } from '@mui/material';
import { Carousel } from 'antd';
import Image from 'next/image';
import { useRef, useState } from 'react';
import GradinetContainer from '../../layouts/gradinet-container/GradinetContainer';
import styles from './ForgotPasswordForm.module.css';

export default function ForgotPasswordForm() {
   const clientReviews = [];
   const emailRef = useRef();
   const [error, setError] = useState(null);
   const [success, setSuccess] = useState(null);
   const [loading, setLoading] = useState(false);

   async function handleFormSubmit(e) {
      e.preventDefault();
      setError(null);
      setSuccess(null);
      setLoading(true);
      const enteredEmail = emailRef.current.value;

      await fetch('/api/user/forgotPassword', {
         method: 'POST',
         body: JSON.stringify({ email: enteredEmail }),
         headers: {
            'Content-Type': 'application/json',
         },
      }).then((res) => {
         if (!res.ok) {
            res.json().then((res) => {
               setError(res.message);
            });
         } else {
            setSuccess('Email sent successfully');
         }
         setLoading(false);
      });
   }

   return (
      <>
         <Stack direction="row" spacing={2} className={styles.container} height="100vh" overflow="hidden">
            <Stack direction="column" width="100%" justifyContent="center" alignItems="center">
               <div className={styles.formInner}>
                  <Typography variant="h2" align="left" width="100%">
                     Forgot Your Password
                  </Typography>
                  <p>
                     We will send you an email with a link to reset your password. If you don't receive an email, please
                     check
                  </p>
                  <form onSubmit={handleFormSubmit} className={styles.form}>
                     <TextField id="email" label="Email" variant="outlined" fullWidth inputRef={emailRef}>
                        <label htmlFor="email">Email</label>
                     </TextField>
                     <LoadingButton
                        variant="contained"
                        fullWidth
                        size="large"
                        type="submit"
                        loading={loading}
                        onClick={handleFormSubmit}
                     >
                        Send Reset Link
                     </LoadingButton>
                  </form>
                  {error && (
                     <Alert severity="error" className={styles.alert}>
                        {error}
                     </Alert>
                  )}
                  {success && (
                     <>
                        <Alert severity="success" className={styles.alert}>
                           {success}
                        </Alert>

                        <Alert severity="info" variant="filled">
                           If you don't receive an email, please check your spam folder, if you still don't see it,
                           please contact us at <a href="mailto:support@premast.com">support@premast.com</a>
                        </Alert>
                     </>
                  )}
               </div>
            </Stack>
            <Stack width="100%" justifyContent="center" alignItems="center" color="white">
               <GradinetContainer>
                  <div className={styles.inner}>
                     <div className={styles.logo}>
                        <Image src="/images/logo-light.svg" alt="logo" width={150} height={70} />
                        <h1>A Whole New World Built For Presentations</h1>
                        <p>Better quality, bigger options, faster outcomes and sleeker designs!</p>
                     </div>
                     <Carousel autoplay>
                        {clientReviews.map((review) => (
                           <div key={review.id} className={styles.review}>
                              <h4>{review.review}</h4>
                              <div className={styles.clientInfo}>
                                 <Image src={review.picture} alt="client" width={50} height={50} />
                                 <div>
                                    <h5>{review.name}</h5>
                                    <p>{review.job}</p>
                                 </div>
                              </div>
                           </div>
                        ))}
                     </Carousel>
                  </div>
               </GradinetContainer>
            </Stack>
         </Stack>
      </>
   );
}
